<div class="welcome-strip">
  <h2>{{ 'App.Name.ResidualValueTracker' | translate }}</h2>
</div>

<div class="no-nav-back_old">
  <div class="col-xs-12 noPad">
  </div>
</div>
